import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Constants from "./../../Utils/Constants";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import CampaignSMSDetailedHistory from "./CampaignSMSDetailedHistory";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";

import LoadingProgress from "./../../Common/LoadingProgress";
import { getToken, getHeaders } from "./../../Utils/Common";
import store from "./../../Common/storage";

import Header from "./../../assets/components/header";

import Pagination from '@material-ui/lab/Pagination';
import { Schedule } from "@material-ui/icons";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import "@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css";
import "react-calendar/dist/Calendar.css";

const StyledTableRow = withStyles((theme) => ({
  root: {
    cursor: "pointer",
    "&:nth-of-type(even)": {
      backgroundColor: "rgba(251, 220, 119, 0.28)",
    },
  },
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
  body: {
    fontSize: 16,
    fontWeight: 600,
    padding: 15,
  },
}))(TableCell);

const columns = [
  {
    id: "name",
    label: `Campaign Name [${store?.get('user')?.partner?.whitelabel_name} Tag]`,
    minWidth: 70,
  },
  { id: "type", label: "Type", minWidth: 50 },
  { id: "description", label: "Description", minWidth: 170 },
  { id: "status", label: "Status", minWidth: 50 },
  { id: "schedule", label: "Send Time", minWidth: 50 },
  {
    id: "created_at",
    label: "Created Time",
    minWidth: 170,
    align: "center",
  },
];

// const status = [
//     /* 0 =>  */ 'Created',                 // Created and ready for configuration                | Step 1 | User 
//     /* 1 =>  */ 'Executed',                // Executed AKA Archived                              | Step 7 | System
//     /* 2 =>  */ 'Pending',                 // Configured and pending execution                   | Step 4 | System
//     /* 3 =>  */ 'In Progress',             // Execution in progress                              | Step 6 | System
//     /* 4 =>  */ 'Failed',                  // Error occured while execution                      | Step 7 | System
//     /* 5 =>  */ 'PartiallyCompleted',      // Partially completed and stopped by user (Pause)    | Step 8 | System
//     /* 6 =>  */ 'Scheduled',               // Configured and waiting for execution time          | Step 2 | User
//     /* 7 =>  */ 'Fetching',                // Fetching contacts from AC                          | Step 3 | System
//     /* 8 =>  */ 'Pushing',                 // Pushing contacts to SP                             | Step 5 | System
//     /* 9 =>  */ 'Cancelled'                // Cancelled or deleted campaign                      | Step 9 | User
// ]

const statuses = [
  /* 0 =>  */ 'In Progress',                // Created and ready for configuration                | Step 1 | User 
  /* 1 =>  */ 'Completed',                  // Executed AKA Archived                              | Step 7 | System
  /* 2 =>  */ 'Completed',                // Configured and pending execution                     | Step 4 | System
  /* 3 =>  */ 'Completed',                // Execution in progress                                | Step 6 | System
  /* 4 =>  */ 'Completed',                  // Error occured while execution                      | Step 7 | System
  /* 5 =>  */ 'Paused',                // Partially completed and stopped by user (Pause)    | Step 8 | System
  /* 6 =>  */ 'In Progress',                  // Configured and waiting for execution time        | Step 2 | User
  /* 7 =>  */ 'In Progress',                // Fetching contacts from AC                          | Step 3 | System
  /* 8 =>  */ 'In Progress',                // Pushing contacts to SP                             | Step 5 | System
  /* 9 =>  */ 'Cancelled',                  // Cancelled or deleted campaign                      | Step 9 | User
  /* 10 => */ '',
  /* 11 => */ 'Scheduled',
  /* 12 => */ 'Waiting for credits'
]

const log_status = [
  /* 0 =>  */ 'In Progress',                 // Created and ready
  /* 1 =>  */ 'Success',                     // sms sent successfully
  /* 2 =>  */ 'Failed',                      // Failed sending sms
  /* 3 =>  */ 'In Progress',                 // Waiting - in progress as waiting for response from service provider
  /* 4 =>  */ 'In Progress',                 // Queued - in prgress to be pused to service provider
]

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: "100%",
  },
});

const scheduledtime = (value) => {
    const timestamp = value; // in seconds

    // Convert to milliseconds
    const inputDate = new Date(timestamp * 1000);
    const currentDate = new Date();

    // Difference in milliseconds
    const diff = currentDate - inputDate;

    // 1 hour in ms
    const oneHour = 60 * 60 * 1000;

    if (diff >= 0 && diff <= oneHour) {
        return "In Progress";
    } else if (diff > oneHour) {
        return "Completed";
    } else {
        return "Scheduled";
    }
};

const getReportAvailabilityText = (value) => {
    const timestamp = value; // in seconds

    const inputDate = new Date(timestamp * 1000);
    const currentDate = new Date();

    const diff = currentDate - inputDate; // ms
    const oneHour = 60 * 60 * 1000;

    // If already older than 1 hour → no message
    if (diff > oneHour) {
        return "";
    }

    // If within last 1 hour
    if (diff >= 0 && diff <= oneHour) {
        return "The report will be available in approximately 1 hour";
    }

    // If in future → calculate (value + 1 hour)
    const availableTime = new Date(inputDate.getTime() + oneHour);

    const minutesLeft = Math.ceil((availableTime - currentDate) / (60 * 1000));

    if (minutesLeft >= 60) {
        const hours = Math.ceil(minutesLeft / 60);
        return `The report will be available in approximately ${hours} hour${hours > 1 ? 's' : ''}`;
    } else {
        return `The report will be available in approximately ${minutesLeft} minute${minutesLeft > 1 ? 's' : ''}`;
    }
};

const CHARACTER_LIMIT = 160;

export default function StickyHeadTable(props) {
  const classes = useStyles();
  const [serverData,      setServerData]      = React.useState(store.get("campaignhistory"));
  const [page,            setPage]            = React.useState(1);
  const [pageCount,       setPageCount]       = React.useState(0);
  const [filterName,      setFilterName]      = React.useState('');
  const [filterDateRange, setFilterDateRange] = React.useState(null);
  const [filterType,      setFilterType]      = React.useState('all');
  let interval = null;

  const handleChange = (event, value) => {
    setPage(value);
  };

  React.useEffect(() => {
    refreshData();

    interval = setInterval(() => {
      refreshData();
    }, 30000);
    return () => {
      clearInterval(interval);
    };
  }, [page, filterName, filterDateRange, filterType]);

  const refreshData = () => {
    let url = Constants.getApiPathWithConfigId(Constants.campaignhistoryApiPath)
      + `?per_page=20&page=${page}&order_by=id&order=desc`;
    if (filterName.trim())
      url += `&name=${encodeURIComponent(filterName.trim())}`;
    if (filterDateRange?.[0])
      url += `&date_from=${filterDateRange[0].toISOString().split('T')[0]}`;
    if (filterDateRange?.[1])
      url += `&date_to=${filterDateRange[1].toISOString().split('T')[0]}`;
    if (filterType !== 'all')
      url += `&type=${filterType}`;

    axios.get(url, getHeaders())
      .then(response => {
        setServerData(response.data.data);
        setPageCount(response.data.meta.last_page);
      })
      .catch(error => console.error(error));
  };

  if (!serverData) {
    return <LoadingProgress />;
  }

  const CampaignHistoryRow = (props) => {
    const row = props.row;
    const rowId = row.id;
    const [show, setShow] = React.useState(false);
    const [serverData, setServerData] = React.useState();

    const getData = () => {
      const config = getHeaders();
      const requestTwo = axios.get(Constants.campaignhistorydetailApiPath, {
        ...config,
        params: {
          campaignId: row.id,
        },
      });
      return axios
        .all([requestTwo])
        .then(
          axios.spread((...responses) => {
            const responseHistory = responses[0];
            setServerData(responseHistory.data.data.campaign);
          })
        )
        .catch((errors) => {
          console.error("error:", errors);
        });
    };

    return (
      <React.Fragment>
        <StyledTableRow
          hover
          role="checkbox"
          tabIndex={-1}
          key={rowId}
          onClick={() => {
            const opposite = !show;
            // setShow(opposite);
            Constants.navigate(Constants.campaignhistorydetails.replace(':id', row.id))
            if (opposite === true) {
              // getData();
              setServerData(row)
            }
          }}
        >
          {columns.map((column) => {
            const value = row[column.id];
            if (column.id === "created_at") {
              return (
                <StyledTableCell>
                  <div className="send-time">
                    <span>{new Date(value).toLocaleString('en-GB', {
                                                                                                            day: 'numeric',
                                                                                                            month: 'numeric',
                                                                                                            year: 'numeric',
                                                                                                            hour: 'numeric',
                                                                                                            minute: '2-digit',
                                                                                                            hour12: true
                                                                                                          })}</span>
                  </div>
                </StyledTableCell>
              );
            } else if(column.id === "type") { //type
              return (
                <StyledTableCell>
                  <span style={{
                    display: 'inline-block',
                    background: value === 'mms' ? '#45A9F0' : '#6B6C7E',
                    color: '#fff',
                    fontSize: '10px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    letterSpacing: '0.04em',
                    padding: '2px 8px',
                    borderRadius: '10px',
                  }}>
                    {value === 'mms' ? 'MMS' : 'SMS'}
                  </span>
                </StyledTableCell>
              );
            } else if(column.id === "status") { //status
              return (
                <StyledTableCell>
                  <div className="send-time">
                    <span>
                      {  
                        statuses[value]
                      }
                    </span>
                  </div>
                </StyledTableCell>
                )
            } else if(column.id === "schedule") { //status
              return (
                <StyledTableCell>
                  <div className="send-time">
                    <span>
                      {
                        `${new Date(value * 1000).toLocaleString('en-GB', {
                                                                            day: 'numeric',
                                                                            month: 'numeric',
                                                                            year: 'numeric',
                                                                            hour: 'numeric',
                                                                            minute: '2-digit',
                                                                            hour12: true
                                                                          })} ${scheduledtime(value) == 'Scheduled' ? ' (Scheduled)' : ''}`
                      }
                    </span>
                  </div>
                </StyledTableCell>
                )
            } else {
              return (
                <StyledTableCell>
                  <div className="send-time">
                    <span>
                      {column.format && typeof value === "number"
                        ? column.format(value)
                        : value == 'null' ? '-' : value}
                    </span>
                  </div>
                </StyledTableCell>
              );
            }
          })}
        </StyledTableRow>
        {show && serverData && (
          <ExpansionPanelDetails style={{ display: "block" }}>
            <div className="row">
              <div className="col col-6">
                <div style={{ padding: "10px" }}>
                  <Typography gutterBottom variant="h5" component="h2">
                  {serverData.name}
                  </Typography>
                  <Typography style={{ color: "grey" }}>
                    List: {serverData.list_ac_names}
                  </Typography>
                  
                  <Typography style={{ color: "grey" }}>
                    Segment: {serverData.segment_ac_names}
                  </Typography>

                  <Typography style={{ color: "grey" }}>
                    Type: {serverData.type}
                  </Typography>
                  {
                    serverData.type == 'mms' && <>
                      <Typography style={{ color: "grey" }}>
                        Subject: {serverData.subject}
                      </Typography>
                      <Typography style={{ color: "grey" }}>
                        File: 
                      </Typography>
                      <img src={serverData.file} width={100} />
                    </>
                  }
                  <Typography style={{ color: "grey" }}>
                    Message: {serverData.message}
                  </Typography>
                  {/* <CampaignSMSDetailedHistory
                    campaignId={row.id}
                    selectedlistcontacts={serverData.list_ac_names}
                    sms_senderid={serverData.sender_id}
                    sms_template={serverData.message}
                  /> */}
                </div>
              </div>
              <div className="col col-6">
               <div style={{ padding: "10px" }}>
                  <Typography gutterBottom variant="h5" component="h2" className="invisible">
                  {'No data '}
                  </Typography>
                  <Typography style={{ color: "grey" }}>
                    Sender ID: {serverData.sender_id}
                  </Typography>
                  <Typography style={{ color: "grey" }}>
                    Total contacts: {serverData.contactlogs_count}
                  </Typography>
                  {/* <Typography style={{ color: "grey" }}>    */}
                    {scheduledtime(serverData.schedule) == "Completed" ? <p
                      className="c-button c-button--secondary text-uppercase text-light w-50"
                      style={{marginTop: '10px'}}
                      onClick={() => {
                        Constants.navigate(Constants.campaignhistorydetails.replace(':id', serverData.id))
                      }}
                    >View Report</p> : <Typography style={{ color: "blue" }}>{
                      getReportAvailabilityText(serverData.schedule)
                    }</Typography>}
                  {/* </Typography> */}
                  
                  {/* <Typography style={{ color: "grey" }}> */}
                    {/* Success: {serverData.contactlogs.length /*filter(e => e.status == 1).length*/} 
                  {/* </Typography> */}

                  {/*<Typography style={{ color: "grey" }}>
                    In Progress : {serverData.contactlogs.filter(e => (
                      e.status == 0 ||
                      e.status == 3 ||
                      e.status == 4)).length}
                  </Typography>
                  <Typography style={{ color: "grey" }}>
                    Failed: {serverData.contactlogs.filter(e => e.status == 2).length}
                  </Typography>*/}
                  
                </div>
              </div>
            </div>
            {/* <CampaignSMSDetailedHistory
              campaignId={row.id}
              selectedlistcontacts={serverData.contactlogs}
              sms_senderid={serverData.sender_id}
              sms_template={serverData.message}
            /> */}
          </ExpansionPanelDetails>
        )}
      </React.Fragment>
    );
  };

  const hasActiveFilter = filterName.trim() || filterDateRange || filterType !== 'all';
  const displayedData = serverData || [];

  return (
    <div className="panal-viewport middle-container">
      <Header name={"SMS Campaign History"} />

      {/* ── Filter bar ── */}
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px', marginBottom: '12px', padding: '10px 0' }}>
        <input
          type="text"
          placeholder="Search by campaign name..."
          value={filterName}
          onChange={(e) => { setFilterName(e.target.value); setPage(1); }}
          style={{
            padding: '6px 12px',
            border: '0.5px solid #BABABA',
            borderRadius: '4px',
            fontSize: '13px',
            fontFamily: 'Open Sans',
            outline: 'none',
            width: '250px',
          }}
        />
        <DateRangePicker
          onChange={(dates) => { setFilterDateRange(dates); setPage(1); }}
          value={filterDateRange}
          clearIcon={null}
        />
        <select
          value={filterType}
          onChange={e => { setFilterType(e.target.value); setPage(1); }}
          style={{
            border: '1px solid #BABABA', borderRadius: '4px',
            padding: '6px 28px 6px 10px', fontSize: '13px', outline: 'none',
            height: '40px', boxSizing: 'border-box',
            fontFamily: 'inherit', color: '#272833', background: '#fff',
            appearance: 'none', WebkitAppearance: 'none', MozAppearance: 'none',
            backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path d='M0 0l5 6 5-6z' fill='%236B6C7E'/></svg>")`,
            backgroundRepeat: 'no-repeat', backgroundPosition: 'right 10px center',
            cursor: 'pointer',
          }}
        >
          <option value="all">All Types</option>
          <option value="sms">SMS</option>
          <option value="mms">MMS</option>
        </select>
        {hasActiveFilter && (
          <span
            style={{ fontSize: '12px', color: '#45A9F0', cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => { setFilterName(''); setFilterDateRange(null); setFilterType('all'); setPage(1); }}
          >
            Clear filters
          </span>
        )}
        {hasActiveFilter && (
          <span style={{ fontSize: '12px', color: '#6B6C7E' }}>
            {displayedData.length} result{displayedData.length !== 1 ? 's' : ''}
          </span>
        )}
      </div>

        <Paper className={`${classes.root} pb-2`}>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow id="table-head_rw">
                  {columns.map((column) => (
                    <StyledTableCell className="table-hd">
                      {column.label}
                    </StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {displayedData.map((row) => (
                  <CampaignHistoryRow row={row} key={row.id} />
                ))}
                {displayedData.length === 0 && (
                  <TableRow>
                    <StyledTableCell colSpan={columns.length} style={{ textAlign: 'center', color: '#BABABA', fontWeight: 'normal' }}>
                      No campaigns match your filters.
                    </StyledTableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {pageCount > 0 && <div className={`${classes.root} mt-3 mb-3 d-flex justify-content-end`}>
                    <Pagination
                      count={pageCount}
                      page={page}
                      onChange={handleChange}
                      variant="outlined"
                      shape="rounded"
                      />
                  </div>}
        </Paper>
    </div>
  );
}
